import * as React from 'react';
import { HeadTitle } from '../../components/head-title/HeadTitle';
import { Newsletter } from '../../components/newsletter/Newsletter';
import { DefaultLayout } from '../../layout/default/DefaultLayout';

// noinspection JSUnusedGlobalSymbols
export default () => {
  // TODO: Add SEO props
  const seo = {
    description: '',
  };

  const newsletterProps = {
    collapsePadding: true,
    iFrameHeight: { mobile: 1480, tablet: 1156, desktop: 1168 },
    url: 'https://pub.s6.exacttarget.com/mfrh2kmo1ra',
  };

  return (
    <DefaultLayout bgColor='#e4e4e4' locale='es-EM' hideBottomPadding={true} seo={seo}>
      <HeadTitle title='Newsletter' />
      <Newsletter {...newsletterProps} />
    </DefaultLayout>
  );
};
